'use client';

/** Full document navigation for `/forms` routes (e.g. microfrontend handoff). */
export function fullNavigationPush(url: string): void {
  globalThis.window?.location.assign(url);
}

export function fullNavigationReplace(url: string): void {
  globalThis.window?.location.replace(url);
}
